import { Outlet } from 'react-router-dom';

import { InventoryWorkloadsCategoryToggle } from '../../_components/InventoryWorkloadsCategoryToggle';
import { InventoryWorkloadsListDateControl } from '../../_components/InventoryWorkloadsListDateControl';
import { InventoryWorkloadsFilters } from '../../_components/InventoryWorkloadsFilters';

export const InventoryWorkloadsList = () => (
  <>
    <InventoryWorkloadsFilters
      categoryToggle={<InventoryWorkloadsCategoryToggle hideDefault />}
      dateControl={<InventoryWorkloadsListDateControl />}
    />
    <Outlet />
  </>
);
